import { Dispatch } from '@reduxjs/toolkit';
import { connect } from 'react-redux';
import { NavigateFunction } from 'react-router-dom';

import CanvasOverview from 'src/pages/Settings/Canvas/Overview';
import { StateType } from 'src/redux/reducers';
import { actions as canvasActions } from 'src/redux/reducers/canvas';

const mapStateToProps = (state: StateType) => ({
  canvasData: state.canvas.collection.data ?? [],
  loading: state.canvas.collection.loading,
  submitting: state.canvas.detail.submitting,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  deleteCanvas: (id: string) => dispatch(canvasActions.requestDeleteCanvas({ id })),
  getCanvases: () => dispatch(canvasActions.requestGetCanvases()),
  updateCanvas: (
    id: string,
    name: string,
    width: number,
    height: number,
    navigate?: NavigateFunction
  ) => dispatch(canvasActions.requestUpdateCanvas({ id, data: { name, width, height }, navigate })),
});

export default connect(mapStateToProps, mapDispatchToProps)(CanvasOverview);
